const _root = jQuery("html, body");

var consoleHolder = console;

function debug(bool) {
  if (!bool) {
    consoleHolder = console;
    console = {};
    Object.keys(consoleHolder).forEach(function(key) {
      console[key] = function() { };
    });
  } else {
    console = consoleHolder;
  }
}

debug(true);

jQuery(function($) {
  $(".barrister-content-switch")
    .find("a")
    .on("click", function(e) {
      $(".barrister-content-switch").find("a").parent().removeClass("active");
      $(this).parent().addClass("active");

      let location = $(this).attr("href");

      $(".barrister-content").removeClass("focused");
      $(location).addClass("focused");

      $("body").trigger("barrister_content_switched", [location]);
    });

  $("body").on("barrister_content_switched", function(e, location) {
    if (location === "#recommendations") {
      $(".testimonials").masonry({
        // options
        itemSelector: ".testimonial",
        gutter: 16,
        // columnWidth: 200
      });
    }
  });

  // If the current url has a hash, scroll to it
  if (window.location.hash) {
    let hash = window.location.hash;
    $(".barrister-content").removeClass("focused");
    $(".barrister-content-switch>li").removeClass("active");
    $('a[href="' + hash + '"')
      .parent()
      .addClass("active");
    $(hash).addClass("focused");
    $("body").trigger("barrister_content_switched", [hash]);
    smoothScrollToAnchor(hash);
  }

  // Smooth scroll to anchor
  $('a[href*="#"]').on("click", function(e) {
    if (this.hash !== "" && this.hash !== "#") {
      smoothScrollToAnchor($(this).attr("href"));
    }
  });

  $("body").on("barrister_reorder", function() {
    let pupil_section = $(".collected-pupils-section");

    if (pupil_section.find("li:not(.hidden)").length <= 0) {
      pupil_section.hide();
    } else {
      pupil_section.show();
    }
  });
});

function smoothScrollToAnchor(hash) {
  _root.stop().animate({
    scrollTop: jQuery(hash).offset().top - (jQuery(".header").height() + 150),
  });
}

_root.bind("scroll mousedown DOMMouseScroll mousewheel keyup", function(e) {
  if (e.which > 0 || e.type === "mousedown" || e.type === "mousewheel") {
    _root.stop();
  }
});

jQuery(function($) {
  $(".main-carousel").flickity({
    // options
    cellAlign: "left",
    groupCells: true,
    contain: true,
    prevNextButtons: true,
  });

  $(".carousel-previous").on("click", function(e) {
    e.preventDefault();

    if ($(this).attr("disabled")) return;

    $(".main-carousel").flickity().flickity("previous");
  });

  $(".carousel-next").on("click", function(e) {
    e.preventDefault();

    if ($(this).attr("disabled")) return;

    $(".main-carousel").flickity().flickity("next");
  });
});

function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() {
      callback.apply(context, args);
    }, ms || 0);
  };
}

function updateUrlParameter(uri, key, value) {
  var url = new URL(uri);
  var search_params = url.searchParams;

  if (key !== undefined) {
    // new value of "id" is set to "101"
    if (Array.isArray(key)) {
    } else {
      search_params.set(key, value);
    }
  }

  // change the search property of the main url
  url.search = search_params.toString();

  // the new url string
  var new_url = url.toString();

  window.history.pushState({ path: new_url }, "", new_url);
}

// document.getElementById('no-js-form-submit').remove();

jQuery(function($) {
  let role_filter = null;
  let service_filter = null;
  let name_filter = null;

  reorder_barristers();

  $(".hero.barrister form").on("submit", function(e) {
    e.preventDefault();
  });

  $('.hero.barrister input[name="s"]').bind(
    "keyup",
    delay(function(e) {
      name_filter = this.value.toLowerCase();

      role_filter = $(".barrister__filters")
        .find('select[data-filter-for="roles"]')
        .val();
      service_filter = $(".barrister__filters")
        .find('select[data-filter-for="service"]')
        .val();

      let event_data = {};

      if (name_filter !== null && name_filter !== "") {
        event_data.name_filter = name_filter;
      }

      if (role_filter !== null && role_filter !== "") {
        event_data.role_filter = role_filter;
      }

      if (service_filter !== null && service_filter !== "") {
        event_data.service_filter = service_filter;
      }

      $("body").trigger("barrister_filter_changed", [event_data]);
    }, 500),
  );

  $(".hero.barrister .barrister__filters")
    .find("select")
    .each(function() {
      $(this).on("change", function() {
        name_filter = $('.hero.barrister input[name="s"]').val().toLowerCase();

        if ($(this).data("filter-for") === "roles") {
          role_filter = $(this).val();
          // console.log(role_filter);
          // updateUrlParameter(window.location.href, 'role', role_filter);
        }

        if ($(this).data("filter-for") === "service") {
          service_filter = $(this).val();
          // updateUrlParameter(window.location.href, 'service', service_filter);
        }

        let event_data = {};

        if (name_filter !== null && name_filter !== "") {
          event_data.name_filter = name_filter;
        }

        if (role_filter !== null && role_filter !== "") {
          event_data.role_filter = role_filter;
        }

        if (service_filter !== null && service_filter !== "") {
          event_data.service_filter = service_filter;
        }

        $("body").trigger("barrister_filter_changed", [event_data]);
        $("body").trigger("barrister_reorder", []);
      });
    });

  /*
   * Currently supported filters:
   * role_filter: Compares a String to the barrister's role that is stored in the data-role attribute (e.g 'kc')
   * service_filter: Compares the parameter to an array that is stored on the element as a data attribute called 'data-services' (e.g clinical-negligence)
   *
   * The barrister filters can be triggered as such:
   * $('body').trigger('barrister_filter_changed', [{ role_filter: 'kc' }]);
   * From anywhere, and the event handler below will be triggered
   *
   * The event handler will then loop through all barristers and hide/show them based on the filters
   */
  $("body").on("barrister_filter_changed", function(e, event_data) {
    $(".barristers").show();
    $(".barrister").removeClass("hidden");

    name_filter = event_data.name_filter || null;
    role_filter = event_data.role_filter || null;
    service_filter = event_data.service_filter || null;

    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.s || params.role || params.service) {
      updateUrlParameter(
        location.protocol + "//" + location.host + location.pathname,
      );
    }

    // console.log(name_filter, role_filter, service_filter);

    $("li.barrister").each(function() {
      if (role_filter !== null && role_filter !== "") {
        let roles = $(this).data("roles");

        // console.log(roles.toString());

        var skip = false;

        if (roles.toString() == "-1") {
          skip = true;
          $(this).addClass("hidden");
          // console.log("Skip: " + $(this).find("h3").text());
        }

        if (roles !== undefined && roles.toString() != "-1" && !skip) {
          if (roles !== role_filter) {
            $(this).addClass("hidden");
          }

          if (roles.includes(role_filter)) {
            $(this).removeClass("hidden");
          }
        }
      }

      if (service_filter !== null && service_filter !== "") {
        let barrister_services = $(this).data("services").split(",");

        if (!barrister_services.includes(service_filter)) {
          $(this).addClass("hidden");
        }
      }

      if (name_filter !== null && name_filter !== "") {
        if (
          $(this).find("h3").text().search(new RegExp(name_filter, "i")) < 0
        ) {
          $(this).addClass("hidden");
        }
      }

      // Find our string within the .barrister__meta_data element
      // Whoever we find, show them
      // If we don't find them, hide them
      let barrister_meta_data = $(this)
        .find(".barrister__meta_data")
        .text()
        .toLowerCase();

      // console.log(barrister_meta_data);
      // console.log(name_filter);

      if (name_filter !== null && name_filter !== "") {
        if (barrister_meta_data.includes(name_filter)) {
          $(this).removeClass("hidden");
        }
      }
    });

    if ($("li.barrister.hidden").length === $("li.barrister").length) {
      $(".barristers").hide();
      $(".none-found-message").removeClass("hidden");
    } else {
      $(".barristers").show();
      $(".none-found-message").addClass("hidden");
    }
  });

  if ($(".gform_confirmation_wrapper").length >= 1) {
    $(".modal__header__title").remove();
  }

  $(".share-profile").on("click", function(e) {
    e.preventDefault();

    $(".share-options").toggleClass("open");
  });

  $(".copy-to-clipboard").on("click", function(e) {
    e.preventDefault();

    let $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(this).data("to-copy")).select();
    document.execCommand("copy");
    $temp.remove();
  });

  $(".back-to-top").on("click", function(e) {
    e.preventDefault();

    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500,
    );
  });

  function reorder_staff() {
    let staff = $(".barrister");
    let debug = false;

    // Different from the Barrister version, we want key words to target rather than exact strings
    // because the field in the CMS is a free text field
    let role_priority_weight = {
      director: -150,
      senior: -100,
      manager: -50,
      assistant: 100,
    };

    staff.each(function() {
      let $this = $(this);
      let role_weight = 0;

      if ($this.hasClass("hidden")) return;

      let role = $(this).data("roles");

      if (role !== undefined && role !== null) {
        if (!role_weight) {
          role_weight = 800;
        }

        let role_keys = Object.keys(role_priority_weight);

        for (const element of role_keys) {
          let role_key = element;

          if (role.includes(role_key)) {
            role_weight += role_priority_weight[role_key];
          }
        }

        // let order = role_priority_weight[role];
        let order = role_weight;

        if (debug) {
          $(this).append(
            '<span class="order" style="bottom: 0; width: 100%;\n' +
            "    position: absolute;\n" +
            "    display: block;\n" +
            "    text-align: center;\n" +
            "    background: var(--color-Red-88);\n" +
            "    color: white;\n" +
            "    padding: 0.5rem;\n" +
            "    border-bottom-left-radius: 12px;\n" +
            '    border-bottom-right-radius: 12px;">' +
            order +
            "</span>",
          );
        }

        $this.css("order", order);
        $this.fadeIn();
      }
    });
  }

  if ($(".post-type-archive-staff").length >= 1) {
    reorder_staff();
  }

  function reorder_barristers() {
    // Barrister re-ordering
    // On Event: Page load
    // Order barristers by:
    // 1. Role
    // 2. Year of Call
    // The above are stored as data attributes on the barrister element {data-role="role" data-year_of_call="year"}

    // Role order -> Silks > Juniors > Pupils
    let debug = false;

    let barristers = $(".barrister");

    let role_priority_weight = {
      kc: -100,
      silk: -100,
      mediator: 100,
      junior: 200,
      "attorney-generals-panel-of-counsel": 300,
      pupil: 400,
    };

    barristers.each(function() {
      let $this = $(this);

      if ($this.hasClass("hidden")) return;

      let year_of_call = $(this).data("year_of_call");
      let month_of_call = $(this).data("month_of_call");
      let role_weight = 0;

      // Roles are an array, find the highest priority role and use that as the weight
      if ($this.data("roles") !== undefined) {
        let roles = $this.data("roles");

        if (roles.length > 0) {
          if (roles.includes(",")) {
            roles = roles.split(",");
          } else {
            roles = [roles];
          }
        } else {
          roles = [];
        }

        roles.forEach(function(role) {
          if (role_priority_weight[role] < role_weight) {
            role_weight = role_priority_weight[role];
          }
        });

        if (!role_weight) {
          role_weight = 800;
        }

        if (!year_of_call) {
          year_of_call = 9999;
        }

        year_of_call = year_of_call * 10;

        if (!month_of_call) {
          month_of_call = 0;
        }

        // Make a date from the year and month of call

        // let date = new Date(year_of_call, month_of_call, 1);
        let order = role_weight + year_of_call + month_of_call;
        // let weight = role_weight * Math.pow(10000, 4);

        // Make role_weight an exponential value so that it has more impact on the order
        // let order = weight + date.getTime();

        if (debug) {
          $(this).append(
            '<span class="order" style="z-index: 999; bottom: 0; width: 100%;\n' +
            "    position: absolute;\n" +
            "    display: block;\n" +
            "    text-align: center;\n" +
            "    background: var(--color-Red-88);\n" +
            "    color: white;\n" +
            "    padding: 0.5rem;\n" +
            "    border-bottom-left-radius: 12px;\n" +
            '    border-bottom-right-radius: 12px;">Order: ' +
            order +
            "</span>",
          );
          // $(this).append('<span class="order" style="z-index: 999; bottom: -2rem; width: 100%;\n' + '    position: absolute;\n' + '    display: block;\n' + '    text-align: center;\n' + '    background: var(--color-Red-88);\n' + '    color: white;\n' + '    padding: 0.5rem;\n' + '    border-bottom-left-radius: 12px;\n' + '    border-bottom-right-radius: 12px;">Weight: ' + weight + '</span>');
          // $(this).append('<span class="order" style="z-index: 999; bottom: -4rem; width: 100%;\n' + '    position: absolute;\n' + '    display: block;\n' + '    text-align: center;\n' + '    background: var(--color-Red-88);\n' + '    color: white;\n' + '    padding: 0.5rem;\n' + '    border-bottom-left-radius: 12px;\n' + '    border-bottom-right-radius: 12px;">DateTime: ' + date.getTime() + '</span>');
          $(this).append(
            '<span class="order" style="z-index: 999; bottom: -2rem; width: 100%;\n' +
            "    position: absolute;\n" +
            "    display: block;\n" +
            "    text-align: center;\n" +
            "    background: var(--color-Red-88);\n" +
            "    color: white;\n" +
            "    padding: 0.5rem;\n" +
            "    border-bottom-left-radius: 12px;\n" +
            '    border-bottom-right-radius: 12px;">Month: ' +
            month_of_call +
            "</span>",
          );
        }
        // $(this).append('<span class="order" style="">' + order + '</span>');

        $this.css("order", order);
        $this.fadeIn();
      }
    });

    if ($("li.barrister.hidden").length === $("li.barrister").length) {
      $(".none-found-message").removeClass("hidden");
    } else {
      $(".none-found-message").addClass("hidden");
    }
  }

  $("body").on("barrister_reorder", function(e, data) {
    reorder_barristers();
  });

  // Find all elements with data-collect-type and get the value of the data-collect attribute
  // Then we can use that value to find the elements with the data field of data-collect-type value and get the values of the data-collect-list attribute
  // Store data-collect-type as a variable called 'type'
  // Using the values in data-collect-list, move values from the page with the data-{type} if they match the value in data-collect-list

  // Example:
  // <div data-collect-type="id" data-collect-list="1955"></div>
  // <div data-id="1955">This is the content</div>
  // The above will move the content from the div with data-id="1955" into the div with data-collect-type="id" data-collect-list="1955"

  $("[data-collect-type]").each(function(index, elem) {
    let $this = $(this);

    let type = $this.data("collect-type");
    let list = $this.data("collect-list").toString();

    if (list.includes(",")) {
      list = list.split(",");
    } else {
      list = [list];
    }

    list.forEach(function(item) {
      let selector = "[data-" + type + '="' + item + '"]';
      let original = $(selector);

      let clone = $(selector).clone();

      $this.append(clone);
      original.remove();
    });

    $this.parent().fadeIn();
  });
});

jQuery(function($) {
  // Category page Year filter

  $('select[name="year_filter"]').on("change", function() {
    let year_filter = $(this).val();

    // Redirect page to base location
    // If /page/ is in the URL, remove it
    // but with year filter as a query string

    // If year_filter is set, replace the value

    let base_url = window.location.href.split("/page/")[0];

    let current_filter = getQueryVars("year_filter");

    let searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has("year_filter")) {
      searchParams.set("year_filter", year_filter);
    } else {
      searchParams.append("year_filter", year_filter);
    }

    window.location.search = searchParams.toString();
  });
});

jQuery(function($) {
  // Get query variables

  let get = getQueryVars();

  $('input[type="checkbox"]').on("change", function() {
    let $this = $(this);
    let $label = $this.parent();

    if ($this.is(":checked")) {
      $label.addClass("checked");
    } else {
      $label.removeClass("checked");
    }
  });

  $(document).on("gform_confirmation_loaded", function(e, form_id) {
    $(".newsletter-modal").addClass("hide-header");
  });

  $("body").on("menu_open", function() {
    $(".menu-phone").removeClass("show-desktop");
  });

  $("body").on("menu_close", function() {
    $(".menu-phone").addClass("show-desktop");
  });
  //add some html after the textarea


  var inputs = [
    {
      'name': 'input_5_5',
      'wordLength': 500
    },
    {
      'name': 'input_1_15',
      'wordLength': 500
    },
    {
      'name': 'input_1_17',
      'wordLength': 250
    },
    {
      'name': 'input_1_18',
      'wordLength': 250
    },
    {
      'name': 'input_1_20',
      'wordLength': 500
    },
  ];

  for (let input = 0; input <= inputs.length; input++) { 
    $('#' + inputs[input].name).after('<div class="charleft ginput_counter"><span class="word-count">0</span>/<span class="total">' + inputs[input].wordLength + '</span> words</div>');
    $('#' + inputs[input].name).attr('data-max-words', inputs[input].wordLength);

    $(document).on('keydown', $('#' + inputs[input].name), function(e) {
      check_words(e);
    });

    $(document).on('keyup', $('#' + inputs[input].name), function(e) {
      check_words(e);
    });
  }
});

jQuery(($) => {
  $ = jQuery;
  $('[data-c-item-state="hidden"]').hide();
  $("[data-carousel]").fadeIn().removeClass("hidden");

  (function() {
    const carousel = document.querySelector("[data-carousel]");

    if (!carousel) return;

    const delay = carousel.getAttribute("data-carousel-delay");
    const items = carousel.querySelectorAll("[data-c-item-state]");
    const itemLength = items.length;
    const fadeTransitionDuration = 1;
    let currentItem = 0;

    if (itemLength === 1) return;

    let tallest = 0;
    items.forEach(function(item) {
      let height = $(item).height();

      // console.log(height);

      if (height > tallest) {
        tallest = height;
      }
    });

    // console.log(tallest);

    if ($(carousel).hasClass("no-height")) {
      $(carousel).height("auto");
    } else {
      $(carousel).height(tallest);
    }

    const next = () => {
      let current_item = $(items[currentItem]);

      current_item.fadeOut(fadeTransitionDuration * 1000, () => {
        items[currentItem].setAttribute("data-c-item-state", "hidden");
        currentItem = currentItem + 1 === itemLength ? 0 : currentItem + 1;
        items[currentItem].setAttribute("data-c-item-state", "visible");
        $(items[currentItem]).fadeIn(fadeTransitionDuration * 1000);
      });
    };

    setInterval(next, delay * 1000);
  })();

  // On page resize, set the height of the carousel to the tallest item
  $(window).on("resize", function() {
    const carousel = document.querySelector("[data-carousel]");
    const items = carousel.querySelectorAll("[data-c-item-state]");
    let tallest = 0;
    items.forEach(function(item) {
      let height = $(item).height();

      if (height > tallest) {
        tallest = height;
      }
    });

    $(carousel).height(tallest);
  });
});

function getQueryVars() {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  let get = {};
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    get[pair[0]] = pair[1];
  }

  return get;
}

function check_words(e) {
  if (undefined === e.target) return;
  wordLength = jQuery(e.target).data('max-words') ?? 500;

  var BACKSPACE = 8;
  var DELETE = 46;
  var MAX_WORDS = wordLength;
  var valid_keys = [BACKSPACE, DELETE];
  var words = e.target.value.split(' ') ? e.target.value.split(' ') : 0;

  if (words.length >= MAX_WORDS && valid_keys.indexOf(e.keyCode) == -1) {
    e.preventDefault();
    words.length = MAX_WORDS;
    e.target.value = words.join(' ');
  }
  var word_count = words.length;
  //find the ginput_counter and update word-count
  var counter = e.target.nextElementSibling?.querySelector('.word-count');

  if   (undefined === counter || null === counter) return;

  if (words == "") {
    word_count = 0;
  }
  counter.textContent = word_count;
}
